import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-spinner',
  template: `
    <div class="spinner">
      <span class="loader"></span>
      @if (text()) {
        <p class="spinner-text" [style.color]="textColor()">{{ text() }}</p>
      }
    </div>
  `,
  styles: [
    `
      .spinner {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        vertical-align: middle;
        margin-top: 2rem;
        gap: 1rem;

        opacity: 0;
        animation-name: fadeIn;
        animation-delay: 300ms;
        animation-fill-mode: forwards;
        z-index: 999;

        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }

        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
        .loader {
          transform: rotateZ(45deg);
          // perspective: 1000px;
          border-radius: 50%;
          width: 68px;
          height: 68px;
          color: var(--theme-accent);
          z-index: 1000;
        }

        .loader:before,
        .loader:after {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: inherit;
          height: inherit;
          border-radius: 50%;
          transform: rotateX(70deg);
          animation: 1s spin linear infinite;
        }
        .loader:after {
          color: var(--theme-primary);
          transform: rotateY(70deg);
          animation-delay: 0.4s;
        }

        @keyframes rotate {
          0% {
            transform: translate(-50%, -50%) rotateZ(0deg);
          }
          100% {
            transform: translate(-50%, -50%) rotateZ(360deg);
          }
        }

        @keyframes rotateccw {
          0% {
            transform: translate(-50%, -50%) rotate(0deg);
          }
          100% {
            transform: translate(-50%, -50%) rotate(-360deg);
          }
        }

        @keyframes spin {
          0%,
          100% {
            box-shadow: 0.2em 0px 0 0px currentcolor;
          }
          12% {
            box-shadow: 0.2em 0.2em 0 0 currentcolor;
          }
          25% {
            box-shadow: 0 0.2em 0 0px currentcolor;
          }
          37% {
            box-shadow: -0.2em 0.2em 0 0 currentcolor;
          }
          50% {
            box-shadow: -0.2em 0 0 0 currentcolor;
          }
          62% {
            box-shadow: -0.2em -0.2em 0 0 currentcolor;
          }
          75% {
            box-shadow: 0px -0.2em 0 0 currentcolor;
          }
          87% {
            box-shadow: 0.2em -0.2em 0 0 currentcolor;
          }
        }

        .spinner-text {
          margin: 0;
          font-size: 1rem;
          text-align: center;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class SpinnerComponent {
  text = input<string>('');
  textColor = input<string>('#666');
}
